import { AddressModel } from "@ifaa-components/ui-components";

export class PersonalDetailsModel {
    firstName: string = '';
    lastName: string = '';
    mobile: string = '';
    dob: string = '';
    gender: number = 0;
    address: AddressModel = new AddressModel();
}